module.exports = __webpack_public_path__ + "static/media/HireRectangleBlue.6aa5dc04.svg";